import { render, staticRenderFns } from "./OddsTable.vue?vue&type=template&id=921ab664&"
import script from "./OddsTable.vue?vue&type=script&lang=js&"
export * from "./OddsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports